<template>
    <svg :width="size" :height="size" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
      d="M5.33333 1.33333H4V12H5.33333V1.33333ZM6.71354 1.81901C6.71242 1.81977 6.71082 1.82181 6.70833 1.82422C6.70307 1.82933 6.6974 1.8356 6.69401 1.84245L10.3522 11.9525L10.3574 11.9583C10.3626 11.9637 10.3694 11.9686 10.3763 11.972L11.6191 11.5137C11.6202 11.5129 11.6224 11.5116 11.625 11.5091C11.6303 11.5039 11.6353 11.4972 11.6387 11.4902L7.98112 1.38086L7.97591 1.375C7.97056 1.36947 7.96358 1.36409 7.95638 1.36068L6.71354 1.81901ZM6.66667 12C6.66667 12.7364 6.06971 13.3333 5.33333 13.3333H1.33333C0.596953 13.3333 0 12.7364 0 12V1.33333C0 0.596954 0.596954 0 1.33333 0H5.33333C5.76251 0 6.14284 0.203917 6.38672 0.51888L7.5026 0.108073V0.109375C8.21578 -0.164924 8.96826 0.259756 9.21875 0.885417C9.22149 0.892254 9.22471 0.899326 9.22721 0.90625L12.8939 11.0397H12.8926C13.1638 11.7518 12.7392 12.5026 12.1146 12.7526C12.1089 12.7549 12.1027 12.757 12.097 12.7591L10.8307 13.2253L10.8301 13.224C10.1171 13.4978 9.365 13.0734 9.11458 12.4479C9.11185 12.4411 9.10863 12.434 9.10612 12.4271L6.66667 5.6849V12ZM1.33333 12H2.66667V1.33333H1.33333V12Z"
      :fill="fill" />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'LibraryIcon',
    props: {
      size: {
        type: [Number, String],
        default: 16,
      },
      fill: {
        type: String,
        default: '#8A8D93',
      },
    },
  };
  </script>